import VMasker from 'vanilla-masker';
import { registerTagmanagerEvent, TagManagerEvent, StartSimulateVariables } from '../../../commons/js/utils/TagManager';

const MIN_VALUE = 5000;
const MAX_VALUE = 400000;
const MONEY_MASK_OPTIONS = {
	precision: 0,
	separator: ',',
	delimiter: '.',
	zeroCents: true,
}

interface ITargetElements {
	form: HTMLFormElement;
	input: HTMLInputElement;
}

export default class AmountRequestForm {
	form: HTMLFormElement;
	inputContainer: HTMLElement;
	input: HTMLInputElement;
	btnSubmit: HTMLButtonElement;
	submitted: boolean = false;
	target: ITargetElements;

	constructor() {
		this.form = document.querySelector<HTMLFormElement>('#amount-request-form')!;
		this.inputContainer = this.form.querySelector<HTMLElement>('.c-money-input')!;
		this.input = this.inputContainer.querySelector<HTMLInputElement>('input')!;
		this.btnSubmit = this.form.querySelector<HTMLButtonElement>('button')!;

		this.target = {
			form: document.querySelector<HTMLFormElement>('#simulation-request')!,
			input: document.querySelector<HTMLInputElement>('input[name=amount]')!,
		};
	}

	public initialize() {
		VMasker(this.input).maskMoney(MONEY_MASK_OPTIONS);

		this.input.addEventListener('input', this.onChange.bind(this));
		this.form.addEventListener('submit', (event: Event) => this.onSubmit(event));
	}

	public onSubmit(event: Event) {
		event.preventDefault();

		if (this.isValid()) {
			const requestedValue = this.getRequestedValue().toString();

			this.target.input.value = requestedValue;
			this.target.input.setAttribute('value', requestedValue)

			this.target.input.dispatchEvent(new Event('change'));
			window.scroll(0, this.target.form.offsetTop);

			registerTagmanagerEvent(TagManagerEvent.START_SIMULATE);

		} else {
			this.inputContainer.classList.add('error');
			this.submitted = true;
		}
	}

	private isValid(): boolean {
		return this.getRequestedValue() >= MIN_VALUE && this.getRequestedValue() <= MAX_VALUE;
	}

	private getRequestedValue(): number {
		return parseInt(VMasker.toNumber(this.input.value??0));
	}

	public onChange() {
		if (!this.submitted) return;

		this.isValid()
			? this.inputContainer.classList.remove('error')
			: this.inputContainer.classList.add('error');
	}
}